import { Box, Checkbox } from "@drone-js/core";
import type { PropertyData } from "libs/codegen/property-onboarding";
import isEmpty from "lodash/isEmpty";
import { useFormContext } from "react-hook-form";
import { useDisableFieldMetadata } from "../form/useDisableFieldMetadata";
import { useFormController } from "../form/useFormController";
import { useOnboardingPageContextAtomValue } from "../onboardingPageContextAtom";

export const ContractCheckboxController = () => {
    const { formState } = useFormContext<PropertyData>();
    const { value, setValue, ref } = useFormController("contractId");
    // contractDetail can transiently be null during page-context transitions
    // (the response targeting a non-publish page doesn't carry contract details).
    // Default to empty so a brief re-render before navigation does not crash.
    const { isInternalUser, contractDetail } = useOnboardingPageContextAtomValue();
    const id = contractDetail?.id ?? "";
    const disableFieldMetadata = useDisableFieldMetadata();

    const isSelected = !isEmpty(value);

    const handleClick = () => {
        if (!isInternalUser && !disableFieldMetadata) setValue(!isSelected ? id : "");
    };

    return (
        <Box onClick={handleClick} data-element-name="ack-terms-conditions" data-testid="ack-terms-conditions">
            <Checkbox
                ref={ref}
                selection={isSelected ? "selected" : "unselected"}
                state={formState.isLoading || isInternalUser || disableFieldMetadata ? "disabled" : "enabled"}
            />
        </Box>
    );
};
